export const packImages = [
  'https://d1rw89lz12ur5s.cloudfront.net/photo/collectorscache/file/768c3720555211e89a532318b466b769/1st%20charizard%20pack.jpg',
  'https://d1rw89lz12ur5s.cloudfront.net/photo/collectorscache/file/2680d750555111e8942bfd5bfeaf0da0/shadowless%20blastoise.jpg',
  'https://d1rw89lz12ur5s.cloudfront.net/photo/collectorscache/file/80669ac0555111e8ae630903bce07812/shadowless%20venusaur.jpg'
];